import { gql } from '@apollo/client';

// ============================================================================
// FRAGMENTS
// ============================================================================

export const GASTO_FRAGMENT = gql`
  fragment GastoFields on Gasto {
    id
    codigo
    categoria_gasto_id
    categoria_gasto {
      id
      nombre
      color
      icono
    }
    proveedor_id
    proveedor {
      id
      nombre
      nombre_comercial
    }
    fecha
    descripcion
    monto
    iva_porcentaje
    iva_monto
    total
    metodo_pago
    referencia_pago
    pagado
    fecha_pago
    recurrente
    frecuencia_recurrencia
    comprobante_url
    numero_factura_proveedor
    notas
    activo
    usuario {
      id
      nombre
      apellido
    }
    created_at
  }
`;

// ============================================================================
// QUERIES
// ============================================================================

export const GET_GASTOS = gql`
  ${GASTO_FRAGMENT}
  query GetGastos(
    $categoria_gasto_id: Int
    $proveedor_id: Int
    $fecha_desde: Date
    $fecha_hasta: Date
    $pagado: Boolean
    $busqueda: String
    $limit: Int
    $offset: Int
  ) {
    gastos(
      categoria_gasto_id: $categoria_gasto_id
      proveedor_id: $proveedor_id
      fecha_desde: $fecha_desde
      fecha_hasta: $fecha_hasta
      pagado: $pagado
      busqueda: $busqueda
      limit: $limit
      offset: $offset
    ) {
      gastos {
        ...GastoFields
      }
      total
    }
  }
`;

export const GET_GASTO = gql`
  ${GASTO_FRAGMENT}
  query GetGasto($id: Int!) {
    gasto(id: $id) {
      ...GastoFields
    }
  }
`;

export const GET_RESUMEN_EGRESOS = gql`
  query GetResumenEgresos($fecha_desde: Date!, $fecha_hasta: Date!) {
    resumenEgresos(fecha_desde: $fecha_desde, fecha_hasta: $fecha_hasta) {
      total_gastos
      total_compras
      total_egresos
      gastos_pendientes_pago
      gastos_por_categoria {
        categoria_id
        categoria_nombre
        color
        total
        cantidad
        porcentaje
      }
      gastos_por_proveedor {
        proveedor_id
        proveedor_nombre
        total
      }
      gastos_por_mes {
        mes
        total_gastos
        total_compras
        total
      }
    }
  }
`;

// ============================================================================
// MUTATIONS
// ============================================================================

export const CREAR_GASTO = gql`
  ${GASTO_FRAGMENT}
  mutation CrearGasto($input: CrearGastoInput!) {
    crearGasto(input: $input) {
      ...GastoFields
    }
  }
`;

export const ACTUALIZAR_GASTO = gql`
  ${GASTO_FRAGMENT}
  mutation ActualizarGasto($id: Int!, $input: ActualizarGastoInput!) {
    actualizarGasto(id: $id, input: $input) {
      ...GastoFields
    }
  }
`;

export const ELIMINAR_GASTO = gql`
  ${GASTO_FRAGMENT}
  mutation EliminarGasto($id: Int!) {
    eliminarGasto(id: $id) {
      ...GastoFields
    }
  }
`;

export const MARCAR_GASTO_PAGADO = gql`
  ${GASTO_FRAGMENT}
  mutation MarcarGastoPagado($id: Int!, $fecha_pago: Date, $referencia_pago: String) {
    marcarGastoPagado(id: $id, fecha_pago: $fecha_pago, referencia_pago: $referencia_pago) {
      ...GastoFields
    }
  }
`;
